module.exports = __webpack_public_path__ + "img/icon-notice.0b88246d.png";